import type { GridColDef } from '@mui/x-data-grid-pro';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
// import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { CostCenter } from 'components/admin-portal/Procedures/Reports/type';
import type { TFunction } from 'i18next';

const useColumnDefinitions = (costCenters: CostCenter[]) => {
  'use memo';

  const { t } = useTranslation('common');

  return columnDefinitions(t, costCenters);
};

const columnDefinitions = (t: TFunction, costCenters: CostCenter[]) => {
  if (!costCenters) {
    return [];
  }

  return [
    {
      field: 'brNames',
      headerName: t('dataPermissions.planUnit'),
      flex: true,
      valueGetter: (_, row: CostCenter) => {
        const currentCostCenterNames = costCenters
          .filter((costCenter) => costCenter.brId === row.brId)
          .map((costCenter) => costCenter.name);

        if (row.brId === -1) {
          return t('allPlanUnits');
        }

        return currentCostCenterNames.join();
      }
    },
    {
      field: 'approveHours',
      type: 'boolean',
      headerName: t('dataPermissions.approveHours'),
      renderCell: ({ value }) => <BooleanCell value={value} />
    }
  ] as GridColDef[];
};

export default useColumnDefinitions;
